// extracted by mini-css-extract-plugin
module.exports = {"pagination":"ApplicationHistoryTable_pagination__1743C","toolBar":"ApplicationHistoryTable_toolBar__1gdzM"};